import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { REQUESTED_SERVICES_PATH } from "../../../../../constants/env";
import { useDialogHandler } from "../../../../hooks/useDialogHandler";
import type { IHistoryWithFrom } from "../../../../interfaces/history-with-from.interface";
import { ServiceRequestShowModalOnBackButton } from "../../../../stores/serviceRequestShowModalOnBackButton";
import ConfirmExitFromServiceRequest from "../../../poppers/ConfirmExitFromServiceRequest";
import HeaderV2 from "../../header-v2";
import useHeaderV2Store from "../../hooks/use-header-v2-store.hook";
import type { IHeaderV2LayoutStore } from "../../stores/header-v2-layout-store";
import { HeaderV2LayoutAction } from "../../stores/header-v2-layout-store";

function ProcedurePageHeader(): JSX.Element {
  const location = useLocation();
  const { setHeaderV2LayoutStore } = useHeaderV2Store();

  const showModalOnClickToBackButton = useAtomValue(ServiceRequestShowModalOnBackButton);

  const { openDialog } = useDialogHandler({
    dialogComponent: (
      <ConfirmExitFromServiceRequest
        onConfirm={showModalOnClickToBackButton?.action || undefined}
        onCancel={showModalOnClickToBackButton?.actionBack || undefined}
      />
    ),
  });

  useEffect(
    function setInitialStateHeader() {
      const headerOptions: IHeaderV2LayoutStore = {
        backButton: {
          url: (location.state as IHistoryWithFrom)?.from ?? REQUESTED_SERVICES_PATH,
          action: showModalOnClickToBackButton.visible ? openDialog : undefined,
        },
        actions: [HeaderV2LayoutAction.chatWithOperator],
      };

      setHeaderV2LayoutStore(headerOptions);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location, showModalOnClickToBackButton.visible]
  );

  return <HeaderV2 />;
}

export default ProcedurePageHeader;
